module.exports = __webpack_public_path__ + "img/ac_unit.b50a3254.svg";